import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { Card, Grid, TextField, MenuItem, Select } from "@mui/material";
import { Navigate, useParams } from "react-router-dom";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

import MediaPickerModal from "Main/Modals/MediaModal";

// 🔥 Wrapper to use params in class component
function withParams(Component) {
  return (props) => <Component {...props} params={useParams()} />;
}

class UpdateCourse extends Component {
  state = {
    id: "",
    course_name: "",
    meta_keys: "",
    level_id: "",
    description: "",
    specification: "",
    selectedImage: null,
    img_alt_text: "",
    meta_key: "",
    meta_description: "",
    levels: [],
    showMediaModal: false,

    notification: false,
    message: "",
    redirect: false,
    loading: false,
  };

  componentDidMount() {
    const { id } = this.props.params;
    this.setState({ id });

    this.getLevels();
    this.getCourseDetails(id);
  }

  // ✅ Get Levels
  getLevels = async () => {
    try {
      if (init() === "success") {
        const resp = await axios.post(Constants.getUrls.getAllLevels, {
          page: 1,
          limit: 100,
        });

        this.setState({
          levels: resp.data.data.rows || [],
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  // 🔥 Get Course Details
  getCourseDetails = async (id) => {
    try {
      if (init() === "success") {
        const resp = await axios.post(Constants.getUrls.getAllCoursesDetails, {
          id,
        });

        const data = resp.data.data;

        this.setState({
          course_name: data.course_name,
          meta_keys: data.meta_keys,
          level_id: data.level_id,
          description: data.description,
          specification: data.specification,
          selectedImage: {
            id: data.image_id,
            image_path: data.image_path,
          },
          img_alt_text: data.img_alt_text,
          // meta_key: data.meta_key,
          meta_description: data.meta_description,
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleDescription = (e) => {
    this.setState({ description: e.target.value });
  };

  handleSpecification = (content) => {
    this.setState({ specification: content });
  };

  // 🔥 Update Submit
  handleSubmit = async (e) => {
    e.preventDefault();

    const {
      id,
      course_name,
      meta_keys,
      level_id,
      description,
      specification,
      selectedImage,
      img_alt_text,
      meta_key,
      meta_description,
    } = this.state;

    if (!selectedImage) {
      return this.setState({
        notification: true,
        message: "Please select an image",
      });
    }

    const payload = {
      id,
      course_name,
      meta_keys,
      level_id,
      image_id: selectedImage.id,
      description,
      specification,
      role_id: 1,
      img_alt_text,
      meta_key,
      meta_description,
    };

    try {
      if (init() === "success") {
        this.setState({ loading: true });

        const resp = await axios.post(Constants.putUrls.updateCourses, payload);

        this.setState({
          notification: true,
          message: resp.data.message || "Updated successfully!",
          loading: false,
        });

        setTimeout(() => {
          this.setState({ redirect: true });
        }, 2000);
      }
    } catch (err) {
      console.log(err);

      this.setState({
        notification: true,
        message: err?.response?.data?.message || "Something went wrong!",
        loading: false,
      });
    }
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/courses" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              bgColor="info"
              borderRadius="lg"
            >
              <MDTypography variant="h6" color="white">
                Update Course
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item sm={6}>
                    <TextField
                      label="Course Name"
                      name="course_name"
                      value={this.state.course_name}
                      onChange={this.handleInput}
                      fullWidth
                    />
                  </Grid>

                  <Grid item sm={6}>
                    <Select
                      value={this.state.level_id}
                      onChange={(e) =>
                        this.setState({ level_id: e.target.value })
                      }
                      style={{ width: "100%", height: "45px" }}
                    >
                      <MenuItem value="">Select Level</MenuItem>
                      {this.state.levels.map((lvl) => (
                        <MenuItem key={lvl.id} value={lvl.id}>
                          {lvl.title}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>

                   <Grid item sm={6}>
                    <MDButton
                      variant="contained"
                      color="info"
                      onClick={() => this.setState({ showMediaModal: true })}
                    >
                      Change Image
                    </MDButton>

                    {this.state.selectedImage && (
                      <img
                        src={
                          Constants.imageDomain +
                          this.state.selectedImage.image_path
                        }
                        style={{ width: 80, height: 80, marginTop: 10 }}
                      />
                    )}
                  </Grid>

                  <Grid item sm={6}>
                    <TextField
                      label="Image Text"
                      name="img_alt_text"
                      value={this.state.img_alt_text}
                      onChange={this.handleInput}
                      fullWidth
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <TextField
                      label="Meta Keys"
                      name="meta_keys"
                      value={this.state.meta_keys}
                      onChange={this.handleInput}
                      fullWidth
                    />
                  </Grid>

                  <Grid item sm={12}>
                    <TextField
                      label="Meta Description"
                      name="meta_description"
                      multiline
                      rows={4}
                      value={this.state.meta_description}
                      onChange={this.handleInput}
                      fullWidth
                    />
                  </Grid>

                 

                  <Grid item sm={12}>
                    <TextField
                      label="Description"
                      multiline
                      rows={4}
                      value={this.state.description}
                      onChange={this.handleDescription}
                      fullWidth
                    />
                  </Grid>

                  <Grid item sm={12}>
                    <SunEditor
                      height={150}
                      setContents={this.state.specification}
                      onChange={this.handleSpecification}
                    />
                  </Grid>
                </Grid>

                <Grid mt={2}>
                  <MDButton variant="contained" color="info" type="submit">
                    {this.state.loading ? "Updating..." : "Update Course"}
                  </MDButton>
                </Grid>
              </form>
            </MDBox>

            <MDSnackbar
              color="success"
              title="Course"
              content={this.state.message}
              open={this.state.notification}
            />

            <MediaPickerModal
              visible={this.state.showMediaModal}
              multiple={false}
              onClose={() => this.setState({ showMediaModal: false })}
              onSelect={(images) => {
                this.setState({
                  selectedImage: images[0],
                  showMediaModal: false,
                });
              }}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}

export default withParams(UpdateCourse);
